import { Component, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'qumra-video',
  styleUrl: 'qumra-video.css',
  shadow: true,
})
export class QumraVideo {
  @Prop() imgSrc: string;
  @Prop() videoSrc: string;

  @State() isPlaying: boolean = false;

  private videoElement: HTMLVideoElement;

  handlePlay = () => {
    if (this.videoElement.paused) {
      this.videoElement.play();
    } else {
      this.videoElement.pause();
    }
  };

  handleVideoState = () => {
    this.isPlaying = !this.videoElement.paused;
  };

  render() {
    return (
      <div class="relative w-full h-full">
        {!this.isPlaying && (
          <div
            id="playButton"
            class="playButton py-[25px] px-[27px] border-[2px] border-white rounded-full absolute left-2/4 top-2/4 transform -translate-x-2/4 -translate-y-2/4 w-[80px] h-[80px] z-10 flex items-center justify-center"
            onClick={this.handlePlay}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.48122 0.752701C2.1865 0.0712866 0.5 0.848042 0.5 2.12577V14.8742C0.5 16.152 2.1865 16.9287 3.48122 16.2473L15.5926 9.87307C16.8025 9.23631 16.8025 7.76369 15.5926 7.12693L3.48122 0.752701Z"
                fill="white"
              />
            </svg>
          </div>
        )}

        {!this.isPlaying ? (
          <img
            src={this.imgSrc}
            class="absolute z-1 object-cover w-[967px] h-[329px] rounded-3xl"
            alt="Background"
            loading="lazy"
          />
        ):

        <video
          ref={(el) => (this.videoElement = el)}
          controls
          class="rounded-3xl w-[967px] h-[329px] shadow-2xl -mt-2/4"
          src={this.videoSrc}
          onPlay={this.handleVideoState}
          onPause={this.handleVideoState}
        ></video>
      }

      </div>
    );
  }
}
